import { FC, useEffect, useState } from "react";
import { User } from "src/api/types";
import PaymentMethodCards from "./payment-method-cards";
import PaymentMethodIbans from "./payment-method-ibans";
import { useLocation } from "react-router-dom";
import UserPaymentMethodVirtualCards from "./payment-method-virtual-cards";

type TTabs = "card" | "iban" | "sepa" | "virtualCards";

type UserPaymentMethodsPageProps = {
  user: User;
};

const UserPaymentMethodsPage: FC<UserPaymentMethodsPageProps> = ({ user }) => {
  const location = useLocation();
  const isBusiness = location.pathname?.includes("business");
  const [currentTab, setCurrentTab] = useState<TTabs>(
    isBusiness ? "iban" : "card",
  );
  const tabs: { code: TTabs; name: string }[] = [];

  if (!isBusiness) {
    tabs.push(
      { code: "card", name: "Card" },
      { code: "virtualCards", name: "Virtual Card" },
    );
  }

  tabs.push({ code: "iban", name: "IBAN" }, { code: "sepa", name: "SEPA" });

  useEffect(() => {
    if (!isBusiness) {
      setCurrentTab("card");
    } else {
      setCurrentTab("iban");
    }
  }, [isBusiness]);
  return (
    <div className="bg-white rounded-[12px] w-full">
      <div className="p-4 relative">
        <div className="mt-[20px]">
          <div className="flex gap-4">
            {tabs.map((item) => (
              <button
                key={item.code}
                className={
                  item.code === currentTab
                    ? "pl-1 pr-1 relative text-primary after:absolute after:w-full after:bottom-[-5px] after:bg-[#232800] after:h-[3px] after:left-0 after:transition-opacity transition-colors"
                    : "pl-1 pr-1 relative text-secondary transition-colors hover:text-primary"
                }
                onClick={() => setCurrentTab(item.code)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-[32px]">
          {currentTab === "card" && <PaymentMethodCards user={user} />}
          {currentTab === "iban" && (
            <PaymentMethodIbans user={user} tab={currentTab} />
          )}
          {currentTab === "sepa" && (
            <PaymentMethodIbans user={user} tab={currentTab} />
          )}
          {currentTab === "virtualCards" && (
            <UserPaymentMethodVirtualCards user={user}  />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserPaymentMethodsPage;
